import { ItemType } from './ItemType';
export function isSequencedFlowItem(item) {
    return item.type === ItemType.SequencedFlow;
}
export function isNonSequencedFlowItem(item) {
    return item.type === ItemType.NonSequencedFlow;
}
export function isQuiz(item) {
    return item.type === ItemType.Quiz;
}
export function isMenuItem(item) {
    return item.type === ItemType.MenuItem;
}
export function isResourcesFolder(item) {
    return item.type === ItemType.ResourcesFolder;
}
export function isItem(item) {
    return (isMenuItem(item) ||
        isQuiz(item) ||
        isSequencedFlowItem(item) ||
        isNonSequencedFlowItem(item) ||
        isResourcesFolder(item));
}
export function isSection(item) {
    return item.type === ItemType.Section;
}
export const isSectionOrSequencedFlow = (item) => {
    return isSection(item) || isSequencedFlowItem(item);
};
export function isHotspot(item) {
    return item.type === ItemType.Hotspot;
}
export function isQuestion(item) {
    return item.type === ItemType.Question;
}
export function isBlindMapQuestion(item) {
    return item.type === ItemType.BlindMapQuestion;
}
export function isHotspotTab(item) {
    return item.type === ItemType.HotspotTab;
}
export function isSequencedFlowStep(item) {
    return item.type === ItemType.SequencedFlowStep;
}
export function isAnswer(item) {
    return item.type === ItemType.Answer;
}
export function isStartingMessage(item) {
    return item.type === ItemType.StartingMessage;
}
export function isAutoProgressableItem(item) {
    return isQuestion(item) || isSequencedFlowStep(item);
}
export const isTestContentItem = (item) => {
    return isBlindMapQuestion(item) || isQuestion(item);
};
export const isSequencedFlowContentItem = (item) => {
    return isSection(item) || isSequencedFlowStep(item);
};
export function isResource(item) {
    return item.type === ItemType.Resource;
}
export function isContentItemType(item) {
    return (isQuestion(item) ||
        isStartingMessage(item) ||
        isHotspotTab(item) ||
        isBlindMapQuestion(item) ||
        isSequencedFlowStep(item) ||
        isResource(item));
}
export const isSequencedFlowSectionOrStep = (item) => isSection(item) || isSequencedFlowStep(item);
export function ensureItemIsHotspot(item) {
    if (!isHotspot(item)) {
        throw Error('Assertion failed: item is not hotspot.');
    }
}
export function ensureItemIsHotspotTab(item) {
    if (!isHotspotTab(item)) {
        throw Error('Assertion failed: item is not hotspot tab.');
    }
}
export function itemHasPosition(item) {
    return isHotspot(item) || isBlindMapQuestion(item) || isSequencedFlowStep(item);
}
export function ensureSection(item) {
    if (!isSection(item)) {
        throw Error('Expected item to be section');
    }
}
export function ensureQuestion(item) {
    if (!isQuestion(item)) {
        throw Error('Expected item to be question.');
    }
}
export function ensureStartingMessage(item) {
    if (!isStartingMessage(item)) {
        throw Error('Expected item to be starting message.');
    }
}
export function ensureSectionOrSequencedFlowItem(item) {
    if (!(isSection(item) || isSequencedFlowItem(item))) {
        throw Error('Expected item to be section or linear flow item');
    }
}
export function ensureSequencedFlowItem(item) {
    if (!isSequencedFlowItem(item)) {
        throw Error('Expected item to be linear flow.');
    }
}
export function ensureNonSequencedFlowItem(item) {
    if (!isNonSequencedFlowItem(item)) {
        throw Error('Expected item to be non linear flow.');
    }
}
export function ensureItemIsContentItemType(item) {
    if (!isContentItemType(item)) {
        throw Error('Expected item to be ContentItemType.');
    }
}
export function ensureIsItem(item) {
    if (!isItem(item)) {
        throw Error('Expected item to be a  MenuItem, Quiz, SequencedFlowItem, NonSequencedFlowItem or ResourcesFolder.');
    }
}
export function ensureIsMenuItem(item) {
    if (!isMenuItem(item)) {
        throw Error('Expected item to be a  MenuItem.');
    }
}
export function ensureIsResourcesFolder(item) {
    if (!isResourcesFolder(item)) {
        throw Error('Expected item to be a Resource folder.');
    }
}
export function ensureIsResource(item) {
    if (!isResource(item)) {
        throw Error('Expected item to be a Resource.');
    }
}
export function ensureIsQuiz(item) {
    if (!isQuiz(item)) {
        throw Error('Expected item to be a Quiz.');
    }
}
export function ensureBlindMapQuestion(item) {
    if (!isBlindMapQuestion(item)) {
        throw Error('Expected item to be a BlindMapQuestion.');
    }
}
export function ensureSequencedFlowStep(item) {
    if (!isSequencedFlowStep(item)) {
        throw Error('Expected item to be a step.');
    }
}
export function ensureNotUndefined(i) {
    if (i === undefined) {
        throw Error('Expected value to not be undefined');
    }
}
